import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import "primereact/resources/themes/saga-green/theme.css";
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import './index.css';


import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Hotsite from './pages/hotsite';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/" element={<Hotsite />} />
    </Routes>
  </BrowserRouter>
);

reportWebVitals();
